import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: '',
    timeout: 30000,
    headers: { 'X-Custom-Header': 'foobar' }
});

export async function getDemo() {
    let result = await axios.get('/portal/training/bysubtype', { params: '' });
    console.log(result)
    return result;
}


export async function getWXMessage() {
    let result = await axiosInstance.get('/message/getAllMessages', { params: '' });
    console.log(result)
    return result;
}
